<template>
  <div>
    <div class="scrollable is-hidden-x">
      <table class="table is-fullwidth is-marginless">
        <thead>
        <tr>
          <th>
            LOT
          </th>
          <th>
            SQUARE FOOTAGE
          </th>
          <th class="price-filter-landlist">
            LOT SIZE
          </th>
        </tr>
        </thead>
        <tr class="spacer">
          <td>&nbsp;</td>
          <td>&nbsp;</td>
          <td class="price-filter-landlist-spacer">&nbsp;</td>
        </tr>
        <tr class="is-hoverable" v-for="lot in landSummary" v-if="lot.currentstatusname === 'Available'" @click="selectLot(lot)"
            :class="{'is-active': activeLot && activeLot.cpidstring === lot.cpidstring}">
          <td>{{ lot.productname }}</td>
          <td>{{ lot.productsize }} sqft</td>
          <td class="price-filter-landlist-item">
                    <span v-if="lot.lotgroup">
                      {{ lot.lotgroup }}
                    </span>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>
<script>

export default {

  name: 'app-land-list',
  mixins: [],
  props: {
    landSummary: {
      type: Array
    }
  },
  data() {
    return {
      activeLot: null,
    }
  },
  watch: {},
  created() {
  },
  methods: {
    selectLot: function (lot) {
      this.activeLot = lot;
      this.$store.dispatch('productTracking', {page: 'lot-click', product: lot})
      this.$emit("setLotNameClick", lot)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/journey/land/LandList.vue